import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { PasswordInput } from '../ui/password-input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';

export const MovementDeleteModal = ({ 
  open, 
  onOpenChange, 
  movement, 
  api, 
  onSuccess 
}) => {
  const [adminCreds, setAdminCreds] = useState({
    admin_username: '',
    admin_password: ''
  });
  const [saving, setSaving] = useState(false);

  const handleDelete = async () => {
    if (!adminCreds.admin_username || !adminCreds.admin_password) {
      toast.error('Ingresa las credenciales de administrador');
      return;
    }

    setSaving(true);
    try {
      const apiInstance = api();
      await apiInstance.delete(`/movements/${movement.id}`, {
        data: adminCreds
      });
      toast.success('Movimiento eliminado y stock revertido');
      onSuccess?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al eliminar');
    } finally {
      setSaving(false);
      onOpenChange(false);
      setAdminCreds({ admin_username: '', admin_password: '' });
    }
  };

  const handleClose = () => {
    setAdminCreds({ admin_username: '', admin_password: '' });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Eliminar Movimiento
          </DialogTitle>
          <DialogDescription>
            Esta acción revertirá los cambios de stock. Se requiere autorización de administrador.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Usuario Administrador</Label>
            <Input
              value={adminCreds.admin_username}
              onChange={(e) => setAdminCreds({ ...adminCreds, admin_username: e.target.value })}
              placeholder="Usuario admin"
            />
          </div>
          <div className="space-y-2">
            <Label>Contraseña</Label>
            <PasswordInput
              value={adminCreds.admin_password}
              onChange={(e) => setAdminCreds({ ...adminCreds, admin_password: e.target.value })}
              placeholder="Contraseña"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={handleDelete} disabled={saving}>
            {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MovementDeleteModal;
